import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getWarehouseListAsync } from '../actions/omsPageActions';

interface WarehouseItem {
  // define your warehouse row shape here if known
  // example:
  // id: number;
  // name: string;
  [key: string]: any;
}

interface PaginationState {
  pageNumber: number;
  count: number;
}

interface WarehouseState {
  loading: boolean;
  warehouseList: WarehouseItem[] | [];
  pagination: PaginationState;
}

const initialState: WarehouseState = {
  loading: false,
  warehouseList: [],
  pagination: {
    pageNumber: 0,
    count: 0,
  },
};

const warehouseSlice = createSlice({
  name: 'warehouseSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getWarehouseListAsync.pending), (state) => {
      state.loading = true;
    });

    builder.addMatcher(isAnyOf(getWarehouseListAsync.rejected), (state) => {
      state.loading = false;
    });

    builder.addMatcher(isAnyOf(getWarehouseListAsync.fulfilled), (state, action) => {
      state.loading = false;
      console.log('Warehouse List Response:', action.payload);

      // Adjust based on your actual backend response
      const res = action.payload;

      state.warehouseList = res?.results?.data || [];
      state.pagination.count = res?.count ?? 0;
      state.pagination.pageNumber = action.meta.arg.paramData.page ?? 1;
    });
  },
});

export default warehouseSlice.reducer;
